import { mergeClassName as e } from "../../utils/data.js";
import t from "./ImageGallery.module.js";
import { GalleryArrows as n, GalleryFrame as r } from "./GalleryFrame.js";
import { clampIndex as i, stepIndex as a } from "./types.js";
import { ImageLightbox as o } from "./ImageLightbox.js";
import { useEffect as s, useState as c } from "react";
import { jsxDEV as l } from "react/jsx-dev-runtime";
import { ArrowsOutSimpleIcon as u } from "@phosphor-icons/react";
//#region lib/components/ImageGallery/ImageGallery.tsx
var d = "/opt/render/project/src/shared-ui/lib/components/ImageGallery/ImageGallery.tsx";
function f({ images: f, isExpandable: p = !1, infinite: m = !1, disableAnimation: h = !1, objectFit: g = "cover", footer: _, onIndexChange: v, onActivate: y, className: b }) {
	let [x, S] = c(0), [C, w] = c(!1), T = f.map((e) => e.src).join("|");
	s(() => {
		S(0);
	}, [T]);
	let E = i(x, f.length), D = f[E];
	s(() => {
		v?.(E);
	}, [E, v]);
	function O(e) {
		S((t) => a(t, e, f.length, m));
	}
	if (!D) return /* @__PURE__ */ l("div", {
		className: e(t.gallery, b),
		"data-testid": "gallery-empty"
	}, void 0, !1, {
		fileName: d,
		lineNumber: 71,
		columnNumber: 16
	}, this);
	let k = y ?? (p ? () => {
		w(!0);
	} : void 0);
	return /* @__PURE__ */ l("div", {
		className: e(t.gallery, b),
		children: [/* @__PURE__ */ l(r, {
			image: D,
			objectFit: g,
			disableAnimation: h,
			footer: _,
			onActivate: k,
			arrows: /* @__PURE__ */ l(n, {
				canPrev: m || E > 0,
				canNext: m || E < f.length - 1,
				onPrev: () => {
					O(-1);
				},
				onNext: () => {
					O(1);
				}
			}, void 0, !1, {
				fileName: d,
				lineNumber: 91,
				columnNumber: 21
			}, this),
			action: p ? /* @__PURE__ */ l("button", {
				type: "button",
				className: t.expand,
				"aria-label": "Expand image",
				"data-testid": "gallery-expand",
				onClick: (e) => {
					e.stopPropagation(), w(!0);
				},
				children: /* @__PURE__ */ l(u, { size: 18 }, void 0, !1, {
					fileName: d,
					lineNumber: 114,
					columnNumber: 29
				}, this)
			}, void 0, !1, {
				fileName: d,
				lineNumber: 104,
				columnNumber: 25
			}, this) : void 0
		}, void 0, !1, {
			fileName: d,
			lineNumber: 84,
			columnNumber: 13
		}, this), p && /* @__PURE__ */ l(o, {
			images: f,
			open: C,
			onClose: () => {
				w(!1);
			},
			initialIndex: E,
			infinite: m,
			disableAnimation: h,
			footer: _,
			onIndexChange: S
		}, void 0, !1, {
			fileName: d,
			lineNumber: 120,
			columnNumber: 17
		}, this)]
	}, void 0, !0, {
		fileName: d,
		lineNumber: 83,
		columnNumber: 9
	}, this);
}
//#endregion
export { f as ImageGallery };
